"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _find2 = _interopRequireDefault(require("lodash/find"));
var _isEmpty2 = _interopRequireDefault(require("lodash/isEmpty"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _reactDom = _interopRequireDefault(require("react-dom"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Selector = _interopRequireDefault(require("../../Common/Selector"));
var _TicketType = _interopRequireDefault(require("../TicketType"));
var _tagsSelect = require("../../../../icons-react/tags-select");
var _excluded = ["types", "value"],
  _excluded2 = ["data"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var CLASS_NAME_PREFIX = _Selector["default"].CLASS_NAME_PREFIX,
  StyledRemove = _Selector["default"].StyledRemove,
  StyledMultiValue = _Selector["default"].StyledMultiValue;
var ticketTypePropTypes = _TicketType["default"].propTypes,
  StyledType = _TicketType["default"].StyledType;
var PLACEHOLDER = 'Все тикеты';
var StyledFilter = (0, _styledComponents["default"])(_Selector["default"]).withConfig({
  displayName: "TicketFilterByType__StyledFilter",
  componentId: "sc-1kdubk2-0"
})(["border:1px solid #e6e9ee;box-sizing:border-box;border-radius:4px;padding:0 3px;", "{margin:2px 2px;}.", "__multi-value{border:none;}.", "__multi-value__label{padding:0;}"], StyledMultiValue, CLASS_NAME_PREFIX, CLASS_NAME_PREFIX);
var StyledMultiValueRemove = (0, _styledComponents["default"])(StyledRemove).withConfig({
  displayName: "TicketFilterByType__StyledMultiValueRemove",
  componentId: "sc-1kdubk2-1"
})(["padding-left:0 !important;"]);
var StyledTicketType = (0, _styledComponents["default"])(_TicketType["default"]).withConfig({
  displayName: "TicketFilterByType__StyledTicketType",
  componentId: "sc-1kdubk2-2"
})(["width:fit-content;"]);
var StyledMultiValueTicketType = (0, _styledComponents["default"])(_TicketType["default"]).withConfig({
  displayName: "TicketFilterByType__StyledMultiValueTicketType",
  componentId: "sc-1kdubk2-3"
})(["", "{padding-right:0;}"], StyledType);
var TicketTypeMultiValueRemove = function TicketTypeMultiValueRemove(props) {
  return /*#__PURE__*/_react["default"].createElement(StyledMultiValueRemove, props, /*#__PURE__*/_react["default"].createElement(_tagsSelect.Remove, null));
};
var TicketFilterByType = /*#__PURE__*/function (_React$PureComponent) {
  function TicketFilterByType(props) {
    var _this;
    (0, _classCallCheck2["default"])(this, TicketFilterByType);
    _this = _callSuper(this, TicketFilterByType, [props]);
    _this.handleChange = _this.handleChange.bind(_this);
    _this.handleRef = _this.handleRef.bind(_this);
    return _this;
  }
  (0, _inherits2["default"])(TicketFilterByType, _React$PureComponent);
  return (0, _createClass2["default"])(TicketFilterByType, [{
    key: "handleChange",
    value: function handleChange(value) {
      var _this$props = this.props,
        name = _this$props.name,
        onChange = _this$props.onChange;
      var formatedValue = Array.isArray(value) ? value.map(function (v) {
        return {
          type: v.type,
          subtype: v.subtype
        };
      }) : null;
      this.el.name = name;
      this.el.value = formatedValue;
      var event = new CustomEvent('change', {
        bubbles: true
      });
      this.el.dispatchEvent(event);
      onChange(event);
    }
  }, {
    key: "handleRef",
    value: function handleRef(ref) {
      this.el = _reactDom["default"].findDOMNode(ref);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
        types = _this$props2.types,
        value = _this$props2.value,
        props = (0, _objectWithoutProperties2["default"])(_this$props2, _excluded);
      if ((0, _isEmpty2["default"])(types)) {
        return null;
      }
      var formatedValue = null;
      if (Array.isArray(value)) {
        formatedValue = value.map(function (v) {
          return (0, _find2["default"])(types, {
            type: v.type,
            subtype: v.subtype
          });
        });
      }
      return /*#__PURE__*/_react["default"].createElement(StyledFilter, (0, _extends2["default"])({}, props, {
        components: {
          MultiValue: TicketFilterByType.renderMultiValue
        },
        isMulti: true,
        isSearchable: true,
        onChange: this.handleChange,
        options: types,
        placeholder: PLACEHOLDER,
        ref: this.handleRef,
        value: formatedValue
      }), function (_ref) {
        var data = _ref.data;
        var subtype = data.subtype,
          type = data.type;
        return /*#__PURE__*/_react["default"].createElement(StyledTicketType, {
          subtype: subtype,
          type: type
        });
      });
    }
  }], [{
    key: "renderMultiValue",
    value: function renderMultiValue(_ref2) {
      var data = _ref2.data,
        innerProps = (0, _objectWithoutProperties2["default"])(_ref2, _excluded2);
      var subtype = data.subtype,
        type = data.type;
      return /*#__PURE__*/_react["default"].createElement("div", innerProps, /*#__PURE__*/_react["default"].createElement(StyledMultiValueTicketType, {
        subtype: subtype,
        type: type,
        suffix: /*#__PURE__*/_react["default"].createElement(TicketTypeMultiValueRemove, innerProps.removeProps)
      }));
    }
  }]);
}(_react["default"].PureComponent);
TicketFilterByType.propTypes = {
  className: _propTypes["default"].string,
  name: _propTypes["default"].string,
  onChange: _propTypes["default"].func,
  types: _propTypes["default"].arrayOf(_propTypes["default"].shape(_objectSpread(_objectSpread({}, ticketTypePropTypes), {}, {
    label: _propTypes["default"].string.isRequired,
    value: _propTypes["default"].string.isRequired
  })).isRequired),
  value: _propTypes["default"].arrayOf(_propTypes["default"].string.isRequired)
};
TicketFilterByType.defaultProps = {
  className: '',
  name: '',
  onChange: Function.prototype,
  types: null,
  value: null
};
var _default = exports["default"] = TicketFilterByType;